export const environment = {
  production: true,
  FRONTEND_BASE_URL: "http://studentportal.wellspringuniversity.app",
  BASE_URL: "//studentportalapi.wellspringuniversity.app",

  logo: "/assets/logos/wellspring1.png",
  short_name: "WellSpring",
  long_name: "WellSpring University",

  nav_links: {
    home: true,
    biodata: true,
    payment: true,
    course: true,
    result: true,
    appointment: true,
    election: true,
    accommodation: true,
    application: true,
  },

  remita: true,
};
